var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGorcerylist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "300px",
    height: "225px",
    viewBox: "695.5 -25 300 225",
    enableBackground: "new 695.5 -25 300 225",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#2B3D56",
    strokeWidth: 10.8436,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    cx: 862.242,
    cy: 147.914,
    r: 22.251
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#2B3D56",
    strokeWidth: 3.6145,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    cx: 862.242,
    cy: 147.914,
    r: 3.216
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2B3D56",
    strokeWidth: 10.8436,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M777.509,125.664 h87.17c9.551,0,18.047-6.066,21.151-15.097L921.754,6.045c3.104-9.032,11.601-15.096,21.151-15.096h26.136"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#2B3D56",
    strokeWidth: 10.8436,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    cx: 781.361,
    cy: 147.914,
    r: 22.252
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#2B3D56",
    strokeWidth: 3.6145,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    cx: 781.36,
    cy: 147.914,
    r: 3.216
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2B3D56",
    strokeWidth: 10.8436,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M890.311,97.532 H773.226c-3.916,0-7.358-2.596-8.437-6.36l-19.856-69.33c-0.99-3.458,1.606-6.903,5.204-6.903H900.23"
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#2B3D56",
    strokeWidth: 7.2291,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 772.188,
    y1: 34.984,
    x2: 911.808,
    y2: 34.984
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#2B3D56",
    strokeWidth: 7.2291,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 784.1,
    y1: 64.653,
    x2: 901.609,
    y2: 64.653
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2B3D56",
    strokeWidth: 7.2291,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M721.959,184.051 c0,0,85.563-28.949,201.031,0"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGorcerylist);
export default __webpack_public_path__ + "static/media/gorcerylist.dad625471a839da5e6c89a091eb03b29.svg";
export { ForwardRef as ReactComponent };